import { NumerosCatalogos } from "../../../../services/v2/numeros.service";

/**
 * Ventana oficial de Meta (Embedded Signup, modo "app WhatsApp Business"): conecta a WAPP un número que vive en la app
 * del teléfono sin sacarlo de ahí. Meta prohíbe registrar esos números por API; solo se pueden conectar así.
 * Regresa el código de la sesión y qué número/cuenta eligió la persona (llega por postMessage desde facebook.com).
 */
export type ResultadoApp = { code: string | null; waba_id: string | null; phone_number_id: string | null };

const cargarSdk = (cat: NumerosCatalogos): Promise<any> => new Promise((ok, mal) => {
	const w = window as any;
	const iniciar = () => { w.FB.init({ appId: cat.meta_app_id, autoLogAppEvents: false, xfbml: false, version: cat.meta_graph || "v23.0" }); ok(w.FB); };
	if (w.FB) { iniciar(); return; }
	w.fbAsyncInit = iniciar;
	const s = document.createElement("script");
	s.src = "https://connect.facebook.net/es_LA/sdk.js";
	s.async = true; s.defer = true; s.crossOrigin = "anonymous";
	s.onerror = () => mal(new Error("No se pudo abrir la ventana de Meta (¿bloqueador de anuncios?)."));
	document.body.appendChild(s);
});

export const conectarDesdeApp = async (cat: NumerosCatalogos): Promise<ResultadoApp> => {
	const FB = await cargarSdk(cat);
	const res: ResultadoApp = { code: null, waba_id: null, phone_number_id: null };
	let cancelado: string | null = null;
	const oir = (ev: MessageEvent) => {
		if (!/facebook\.com$/.test(new URL(ev.origin).hostname)) return;
		try {
			const d = typeof ev.data === "string" ? JSON.parse(ev.data) : ev.data;
			if (d?.type !== "WA_EMBEDDED_SIGNUP") return;
			if (String(d.event || "").startsWith("FINISH")) {
				res.waba_id = d.data?.waba_id || null;
				res.phone_number_id = d.data?.phone_number_id || null;
			} else if (d.event === "CANCEL" && !d.data?.error_message) {
				cancelado = d.data?.current_step ? "Se cerró la ventana de Meta en el paso " + d.data.current_step + "." : "Se cerró la ventana de Meta.";
			} else if (d.event === "ERROR" || d.event === "CANCEL") {   // Meta reports user-facing errors as CANCEL + error_message
				cancelado = "Meta dijo: " + (d.data?.error_message || "error sin detalle");
			}
		} catch { /* mensajes de facebook.com que no son de esta ventana */ }
	};
	window.addEventListener("message", oir);
	try {
		const r: any = await new Promise((ok) => FB.login(ok, {
			config_id: cat.meta_es_config, response_type: "code", override_default_response_type: true,
			// Embedded Signup v4 (v2/v3 retired 15-oct-2026); same extras Meta's Embedded Signup Builder generates for this config.
			extras: { featureType: "whatsapp_business_app_onboarding", sessionInfoVersion: "3", version: "v4" },
		}));
		res.code = r?.authResponse?.code || null;
		await new Promise((ok) => setTimeout(ok, 800));   // el postMessage con el número a veces llega después del callback
		if (!res.phone_number_id && !res.code) throw new Error(cancelado || "Se cerró la ventana de Meta sin conectar el número.");
		if (!res.phone_number_id && cancelado) throw new Error(cancelado);
		return res;
	} finally {
		window.removeEventListener("message", oir);
	}
};
